import './RedefinePassword.css';
import { useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { validatePassword } from '../../utils/format'
import Button from '../../components/button/Button';
import Input from '../../components/input/Input';

import redefinePasswordIcon from '../../assets/check_circle.svg';
import { changePassword, resetPassword } from '../../services/userService';

import { useBrandContext } from "../../context/BrandContext";

//necessario atualizar chamada de redefinição de senha.
const RedefinePassword = () => {

    type Inputs = { newPassword: string, confirmPassword: string };
    type Touched = Partial<Record<keyof Inputs, boolean>>;
    type Errors = Partial<Record<keyof Inputs, string>>
    const [form, setForm] = useState<Inputs>({ newPassword: '', confirmPassword: ''});
    const [touched, setTouched] = useState<Touched>({});
    const [errorsValidate, setErrorsValidate] = useState<Errors>({})
    const [errorFetch, setErrorFetch] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();
    //const location = useLocation();
    const { token } = useParams();

    // Esta rota atende tanto o reset pedido pelo app nativo quanto a conta criada por
    // importacao em lote. Nos dois casos o usuario vive no aplicativo, nao aqui -- entao
    // source=nativeapp faz a tela de sucesso parar de empurrar o login do webapp.
    const [searchParams] = useSearchParams();
    const source = searchParams.get('source');

    const brandContext = useBrandContext();
    // const routePaths = location.pathname.split('/');

    const validate = (newInputs: Inputs) : Errors =>  {
        let newErrors: Errors = {};
        if(!form.newPassword.trim()){
            newErrors.newPassword = "Campo Obrigatório"
        } else if(!validatePassword(newInputs.newPassword)){
            newErrors.newPassword = "A senha precisa ter pelo menos 6 caracteres. \nPor favor, tente novamente."
        }

        if(!form.confirmPassword.trim()){
            newErrors.confirmPassword = "Campo Obrigatório"
        } else if(!validatePassword(newInputs.confirmPassword)){
            newErrors.confirmPassword = "A senha precisa ter pelo menos 6 caracteres. \nPor favor, tente novamente."
        } else if(newInputs.confirmPassword !== newInputs.newPassword) {
            newErrors.confirmPassword = "A confirmação de senha deve ser igual à nova senha"
        }

        setErrorsValidate(newErrors);
        return newErrors;
    }


    const handleKeyPress = (event: any) => {
        if (event.key === ' ') {
          event.preventDefault();
        }
      };

    const handleShowNewPassword = () => {
        setShowNewPassword(showNewPassword => !showNewPassword)
    }

    const handleShowConfirmNewPassword = () => {
        setShowConfirmPassword(showConfirmPassword => !showConfirmPassword)
    }

    const handleSubmit = async (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        const errors = validate(form);
        if (Object.keys(errors).length === 0) {
            setIsLoading(true);
            const payload = {
                password: form.newPassword,
                token,
              };
            try {
                const response = await resetPassword(payload)
                if (response.status === 200){
                    // repassa a origem: quem decide a mensagem final e a tela de sucesso
                    const query = source ? `?source=${encodeURIComponent(source)}` : '';
                    navigate(`/${brandContext.brandName}/sucessRedefinePassword${query}`)
                }

                setIsLoading(false);
                setErrorFetch('');
            } catch (error: any) {
                setIsLoading(false);
                console.log(error)
                if(error?.response?.data?.message === 'Error: Incorrect password.') {
                    setErrorFetch('Senha atual incorreta. Por favor, tente novamente.');
                } else if (error?.message === 'Network Error') {
                    setErrorFetch('Sua conexão está instável. Por favor, tente mais tarde.');
                }
                else {
                    setErrorFetch('Falha no servidor. Por favor tente novamente.');
                }
            }
        }
    };

    return (
        <div className='redefine-password-wrapper'>
            <div className="redefine-password-container">
                <form onSubmit={handleSubmit} className="redefine-password-form">
                    <div className='redefine-password-fields'>
                    <span className='switch-password-title'>Crie uma nova senha</span>
                        <Input
                            htmlFor='newPassword'
                            type={showNewPassword ? "text" : "password"}
                            id='newPassword'
                            labelName='Nova senha'
                            className= {errorsValidate.newPassword ? "input-pattern error-input" : "input-pattern"}
                            placeholder="Nova senha"
                            value={form.newPassword}
                            onKeyDown={event => handleKeyPress(event)}
                            onChange={event => {
                                setForm({ ...form, newPassword: event.target.value })
                            }}
                            onBlur={() => setTouched({ ...touched, newPassword: true })}
                            isErrorValidate = { errorsValidate.newPassword ? true : false}
                            isPassword = {true}
                            handleShowPassword = {handleShowNewPassword}
                            showPassword = {showNewPassword}
                            messageError = { errorsValidate.newPassword }
                            style={{ flexGrow: 1, marginRight: '-19px'}}
                        />

                        <Input
                            htmlFor='confirmPassword'
                            type={showConfirmPassword ? "text" : "password"}
                            id='confirmPassword'
                            labelName='Confirme nova senha'
                            className= {errorsValidate.confirmPassword ? "input-pattern error-input" : "input-pattern"}
                            placeholder="Confirme sua nova senha"
                            value={form.confirmPassword}
                            onKeyDown={event => handleKeyPress(event)}
                            onChange={event => {
                                setForm({ ...form, confirmPassword: event.target.value })
                            }}
                            onBlur={() => setTouched({ ...touched, confirmPassword: true })}
                            isErrorValidate = { errorsValidate.confirmPassword ? true : false}
                            isPassword = {true}
                            handleShowPassword = {handleShowConfirmNewPassword}
                            showPassword = {showConfirmPassword}
                            messageError = { errorsValidate.confirmPassword }
                            style={{ flexGrow: 1, marginRight: '-19px'}}
                        />

                        <b className='error-fetch-redefine-password'> {errorFetch ? errorFetch : null}</b>
                        <Button
                            style={{backgroundColor: brandContext.brandBgColor ? brandContext.brandBgColor: '#3CCC10', color: '#FFFFFF', marginTop: '33px'}}
                            type= 'submit'
                            children = "Salvar nova senha"
                            image={<img alt='redefine-password-icon' src={redefinePasswordIcon}/>}
                            loading={isLoading}
                            disabled={isLoading}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RedefinePassword;